// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// AUTOMATION SCHEDULE SCHEMA
/////////////////////////////////////////

export const AutomationScheduleSchema = z.object({
  daysOfWeek: z.number().int().array(),
  startHour: z.number().int(),
  endHour: z.number().int(),
  timezone: z.string().nullable(),
})

export type AutomationSchedule = z.infer<typeof AutomationScheduleSchema>

export default AutomationScheduleSchema;
